import { Component, EventEmitter, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DrillPauseReason } from 'src/app/bo/drill-pause-reason';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-drill-pause-reason-modal',
  templateUrl: './drill-pause-reason-modal.component.html',
  styleUrls: ['./drill-pause-reason-modal.component.scss'],
  standalone: false,
})
export class DrillPauseReasonModalComponent implements OnInit {
  dataEmitter = new EventEmitter<DrillPauseReason>();
  deleteEmitter = new EventEmitter<number>();

  reason: DrillPauseReason;
  isEdit = false;
  showError = false;
  showDeleteConfirm = false;

  constructor(
    public bsModalRef: BsModalRef,
    private readonly http: HttpService,
    public readonly fonctionsService: FonctionsService,
  ) {}

  ngOnInit(): void {}

  onSubmit() {
    if (!this.reason.title?.trim()) {
      this.showError = true;
      setTimeout(() => { this.showError = false; }, 1500);
      return;
    }
    if (this.isEdit) {
      this.http.put<DrillPauseReason, DrillPauseReason>('DrillSessions/pausereasons', this.reason).subscribe({
        next: (updated) => {
          this.dataEmitter.emit(updated);
          this.fonctionsService.launch_toast(true);
          this.bsModalRef.hide();
        },
        error: () => {
          this.fonctionsService.launch_toast(false);
          this.bsModalRef.hide();
        },
      });
    } else {
      this.http.post<DrillPauseReason, DrillPauseReason>('DrillSessions/pausereasons', this.reason).subscribe({
        next: (created) => {
          this.dataEmitter.emit(created);
          this.fonctionsService.launch_toast(true);
          this.bsModalRef.hide();
        },
        error: () => {
          this.fonctionsService.launch_toast(false);
          this.bsModalRef.hide();
        },
      });
    }
  }

  onDelete() {
    this.http.delete<boolean>(`DrillSessions/pausereasons/${this.reason.drillPauseReasonId}`).subscribe({
      next: () => {
        this.deleteEmitter.emit(this.reason.drillPauseReasonId);
        this.fonctionsService.launch_toast(true);
        this.bsModalRef.hide();
      },
      error: () => {
        this.fonctionsService.launch_toast(false);
        this.bsModalRef.hide();
      },
    });
  }
}
